import OrderModel from '../../../../../base/models/appointmentManagement/dashboard/dashboardModel';

export const getResourceTypeText = (resourceType: number) => {
    if (resourceType === 1) return 'Lounge';
    if (resourceType === 2) return 'Meeting Room';
    if (resourceType === 3) return 'Safe Box';
    return '-';
};

export const getCheckTimeText = (item: OrderModel) => {
    if (item.complete_time && item.go_out_complete_time) {
        return `${item.complete_time.split(' ')[1]} - ${item.go_out_complete_time.split(' ')[1]}`;
    }
    if (!item.complete_time && !item.go_out_complete_time) {
        return '-';
    }
    const completeTime = item.complete_time ? item.complete_time.split(' ')[1] : '';
    const goOutTime = item.go_out_complete_time ? item.go_out_complete_time.split(' ')[1] : '';
    const separator = item.complete_time ? ' - ' : '';
    return `${completeTime}${separator}${goOutTime}`;
};

export const getTimeRangeText = (item: OrderModel) => {
    const startTime = item.start_time ? item.start_time : '-';
    const endTime = item.end_time ? item.end_time : '-';
    return `${startTime}${item.start_time ? ' - ' : ''}${endTime}`;
};
